<template>
  <div class="yht-backStage-position">
    <div class="yht-backStage-position_add te-center cp" @click="addPosition">添加岗位</div>
    <div class="yht-backStage-position_table mt20">
      <el-table
        v-loading="loading"
        ref="table"
        height="calc(100% - 50px)"
        tooltip-effect="light"
        :data="positionList">
        <el-table-column label="" width="20" key="1"></el-table-column>
        <el-table-column label="序号" key="2">
          <span slot-scope="scope">{{ scope.$index + (pageNo - 1) * pageSize + 1 }}</span>
        </el-table-column>
        <el-table-column prop="positionName" label="岗位名称" key="3">
          <span slot-scope="scope" :title="scope.row.positionName">{{scope.row.positionName}}</span>
        </el-table-column>
        <el-table-column label="操作" key="4" width="170">
          <template slot-scope="scope">
            <div class="flex">
              <div class="yht-backStage-position_table_modify mr20 cp" :title="'编辑'" @click="modifyPosition(scope.row)"></div>
              <div class="yht-backStage-position_table_delete cp" :title="'删除'" @click="deletePosition(scope.row)"></div>
            </div>
          </template>
        </el-table-column>
        <template slot="empty">
          <span class="mt10" style="display:block;font-size: 12px;color: #666666;">暂无查询数据</span>
        </template>
      </el-table>
      <!-- 页码 -->
      <div class="yht-backStage-position_page yht-backStage-page">
        <el-pagination
          v-show="total>15 && !loading"
          background
          layout="total, prev, pager, next"
          :current-page="pageNo"
          :page-size="pageSize"
          :total="total"
          @current-change="changePage">
        </el-pagination>
      </div>
    </div>
    <div class="yht-backStage_dialog">
      <el-dialog :title="positionDialog" width="500px" :visible="showPosition"
                 :close-on-click-modal="false"
                 :before-close="handlePositionCancel">
        <div class="yht-backStage_dialog_input" v-show="positionDialog === '添加岗位' || positionDialog === '编辑岗位'">
          <div class="yht-backStage_dialog_label">岗位名称</div>
          <el-input v-model.trim="positionName" placeholder="" maxlength="255"></el-input>
        </div>
        <div class="yht-backStage_dialog_delete te-center mt20" v-show="positionDialog === '删除岗位'">
          <span>是否删除岗位：</span>
          <span v-text="selectPosition.positionName"></span>
        </div>
        <div class="yht-backStage_dialog_btnBox mt30">
          <div class="yht-backStage_dialog_btn yht-backStage_dialog_btnConfirm" @click="handleConfirm">确认</div>
          <div class="yht-backStage_dialog_btn yht-backStage_dialog_btnCancel" @click="handlePositionCancel">取消</div>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>

import axios from 'axios'

export default {
  name: 'position',
  data () {
    return {
      loading: false,
      pageNo: 1,
      pageSize: 15,
      total: 0,
      // 岗位数组
      positionList: [],
      // 岗位弹窗显示与否
      showPosition: false,
      // 弹窗title
      positionDialog: '',
      // 岗位名称
      positionName: '',
      // 编辑和删除时选中的岗位
      selectPosition: {}
    }
  },
  props: {
  },
  mounted () {
    this.getAllPon()
  },
  methods: {
    // 获取所有岗位
    getAllPon () {
      const self = this
      self.loading = true
      const data = {
        pageNo: this.pageNo,
        pageSize: this.pageSize
      }
      axios.post('/yuhuamenhu/position/getAllPon', data).then(json => {
        if (json.data.code === 200) {
          self.positionList = json.data.data.rows
          self.total = json.data.data.totalRows
        } else {
          self.$message.warning(json.data.errorMessage)
        }
      }).catch(err => {
        console.log(err)
      }).finally(() => {
        self.loading = false
      })
    },

    // 分页操作
    changePage (val) {
      this.pageNo = val
      this.getAllPon()
    },

    // 添加岗位
    addPosition () {
      this.positionDialog = '添加岗位'
      this.showPosition = true
    },

    // 修改岗位
    modifyPosition (param) {
      this.selectPosition = param
      this.positionName = param.positionName
      this.positionDialog = '编辑岗位'
      this.showPosition = true
    },

    // 删除岗位
    deletePosition (param) {
      this.selectPosition = param
      this.positionDialog = '删除岗位'
      this.showPosition = true
    },

    // 关闭弹窗
    handlePositionCancel () {
      this.positionName = ''
      this.showPosition = false
    },

    // 点击确认
    handleConfirm () {
      if (this.positionDialog === '添加岗位') {
        this.savePosition()
      } else if (this.positionDialog === '编辑岗位') {
        this.updatePosition()
      } else {
        this.delByCorrId()
      }
    },

    // 添加岗位
    savePosition () {
      const self = this
      if (self.positionName === '') {
        self.$message.warning('添加的岗位名称不能为空！')
        return
      }
      const data = {
        positionName: this.positionName
      }
      axios.post('/yuhuamenhu/position/savePosition', data).then(json => {
        if (json.data.code === 200) {
          self.$message.success(json.data.data)
          self.handlePositionCancel()
          self.getAllPon()
        } else {
          self.$message.warning(json.data.errorMessage)
        }
      }).catch(err => {
        console.log(err)
      })
    },

    // 编辑岗位
    updatePosition () {
      const self = this
      if (self.positionName === '') {
        self.$message.warning('编辑后的岗位名称不能为空！')
        return
      }
      if (self.positionName === self.selectPosition.positionName) {
        self.$message.warning('修改后的岗位名称与原岗位名称相同！')
        return
      }
      const data = {
        correspondingId: this.selectPosition.correspondingId,
        positionName: this.positionName
      }
      axios.post('/yuhuamenhu/position/updatePosition', data).then(json => {
        if (json.data.code === 200) {
          self.$message.success(json.data.data)
          self.handlePositionCancel()
          self.getAllPon()
        } else {
          self.$message.warning(json.data.errorMessage)
        }
      }).catch(err => {
        console.log(err)
      })
    },

    // 删除岗位
    delByCorrId () {
      const self = this
      const data = {
        correspondingId: this.selectPosition.correspondingId
      }
      axios.post('/yuhuamenhu/position/delByCorrId', data).then(json => {
        if (json.data.code === 200) {
          self.$message.success(json.data.data)
          self.handlePositionCancel()
          self.getAllPon()
        } else {
          self.$message.warning(json.data.errorMessage)
        }
      }).catch(err => {
        console.log(err)
      })
    }
  }
}
</script>

<style>
  .yht-backStage-position {
    position: relative;
    padding: 30px;
    width: 100%;
    height: calc(100% - 40px);
    border-radius: 10px;
    background: #FFFFFF;
    box-shadow: 0 4px 50px 8px rgba(0, 0, 0, 0.06);
  }

  .yht-backStage-position_add {
    width: 98px;
    height: 36px;
    line-height: 36px;
    color: #8B1D13;
    border-radius: 4px;
    background: #FFFFFF;
    border: 1px solid #8B1D13;
  }

  .yht-backStage-position_add:hover {
    color: #fff;
    background: #8B1D13;
  }

  .yht-backStage-position_table {
    width: 100%;
    height: calc(100% - 58px);
  }

  .yht-backStage-position_table_modify {
    width: 15px;
    height: 18px;
    background: url("../images/gwgl_modify.png");
    background-size: 100% 100%;
  }

  .yht-backStage-position_table_delete {
    margin-top: 1px;
    width: 16px;
    height: 16px;
    background: url("../images/gwgl_delete.png");
    background-size: 100% 100%;
  }

  .yht-backStage-position_page {
    position: relative;
    margin-top: 10px;
    width: 100%;
    height: 50px;
  }

  .yht-backStage-position_page .el-pagination {
    position: absolute;
    top: 50%;
    left: 45%;
    transform: translate(-50%, -50%);
  }

  .yht-backStage_dialog_input {
    display: flex;
    margin-top: 15px;
    height: 44px;
    line-height: 44px;
  }

  .yht-backStage_dialog_input .el-input__inner{
    height: 44px;
    line-height: 44px;
    font-size: 16px;
    color: #222;
    background-color: #F0F0F0;
    border-color: #F0F0F0;
  }

  .yht-backStage_dialog_label {
    margin-right: 10px;
    font-size: 16px;
    color: #222;
    white-space: nowrap;
  }

  .yht-backStage_dialog_delete {
    font-size: 16px;
    color: #222;
  }
</style>
